import { Record } from 'immutable'

export class Unit extends Record({
    id: undefined,
    name: undefined,
    code: undefined,
}) {}
